import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginButton = () => {        
    const navigate = useNavigate();    
    const login = async () => {
        console.log("Initiating login...");
        try {
            // Generate random state for CSRF protection            
            const state = Math.random().toString(36).substring(2, 15);
            sessionStorage.setItem('okta_auth_state', state);                                            
            window.location.href = `${process.env.REACT_APP_OKTA_AUTHORIZATION_SERVER_URL}?response_type=code&client_id=${process.env.REACT_APP_OKTA_CLIENT_ID}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_OKTA_AUTH_REDIRECT_URI)}&scope=openid%20profile%20email&state=${state}`;         
        } catch (error) {
            console.error('Login initialization failed:', error);
            navigate('/error', {
                state: {
                    error: 'Login initialization failed',
                    details: error.message
                }
            });
        }
    };

    return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
          padding: '20px',
          gap: '24px'
        }}>
          <p style={{
            fontSize: '18px',
            color: '#333',
            maxWidth: '500px',
            lineHeight: '1.5'
          }}>
            To access the In-Context Preview feature, please authenticate with your Okta credentials
          </p>
          
          <button 
            onClick={login}
            className="okta-login-btn"
            style={{
              padding: '12px 24px',
              backgroundColor: '#007dc1',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'background-color 0.2s',
              ':hover': {
                backgroundColor: '#0069a7'
              }
            }}
          >
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
              <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0Z" fill="white"/>
              <path d="M12.8 8C12.8 6.2 11.7 4.6 10 4C9.9 3.9 9.7 4.1 9.8 4.2C10.9 5.3 11.5 6.7 11.5 8.2C11.5 9.7 10.9 11.1 9.8 12.2C9.7 12.3 9.9 12.5 10 12.4C11.7 11.8 12.8 10.2 12.8 8Z" fill="#007DC1"/>
            </svg>
            Login with Okta
          </button>
        </div>
      );
};

export default LoginButton;